<template>
    <span class="tab-count notranslate">
        {{ count }}
    </span>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'TabCount',
        props: {
            count: {
                type: Number,
                default: 0,
            },
        },
    });
</script>

<style lang="scss">
.tab-item {
    .tab-count {
        display: inline-block;
        padding: 0 5px;
        background-color: $primary-color-3;
        border-radius: 0.3rem;
        color: #d3e7fe;
        word-break: keep-all;

        .VI_VN & {
            padding: 0 2px;
        }
    }
}

.tab-item._active {
    .tab-count {
        margin-left: 0.2rem;
        background-color: #d4e8ff;
        color: #3575d1;
        font-weight: 600;
    }

    .svgIcon {
        fill: #efefef !important;
    }
}
</style>
